<!-- Seção Quem Somos (paisagem do início como fundo) -->
<app-igloo-hero mode="landscape">
  <h1 class="quem-somos-title">Quem Somos</h1>
  <p class="quem-somos-subtitle">A <span class="highlight-blue">IglooCode</span> é um estúdio digital especializado em criar sites<br>que geram resultado de verdade para o seu negócio.</p>
</app-igloo-hero>

<!-- Seção Sobre a IglooCode -->
<section class="sobre-section">
  <div class="sobre-container">
    <div class="sobre-image">
      <img src="assets/img/logo.png" alt="IglooCode">
    </div>
    <div class="sobre-text">
      <h2 class="sobre-title">Sobre a <span class="highlight-blue">IglooCode</span></h2>
      <p>A IglooCode nasceu com uma missão simples: entregar <span class="highlight-blue">sites de alto nível</span> para negócios que querem crescer no digital, sem burocracia, sem enrolação.</p>
      <p>Aqui você não fala com um vendedor nem cai em fila de espera. Fala direto com quem vai <span class="highlight-blue">construir o seu projeto</span>, do primeiro pixel ao ar.</p>
      <p>Cada detalhe é pensado para que o seu site não seja apenas bonito, mas que <span class="highlight-blue">convença, converta e venda</span>.</p>
    </div>
  </div>
</section>

<!-- Seção Fundador -->
<section class="fundador-section">
  <div class="fundador-container">
    <div class="fundador-header">
      <h2 class="fundador-section-title">Quem está <span class="highlight-blue">por trás</span></h2>
      <p class="fundador-section-sub">Conheça o fundador da IglooCode</p>
    </div>

    <div class="fundador-card">
      <div class="fundador-img-wrapper">
        <img src="assets/img/nico2.png" alt="Nícolas da Mota">
      </div>
      <div class="fundador-info">
        <span class="fundador-role">Fundador & CEO</span>
        <h3 class="fundador-name">Nícolas da Mota</h3>
        <p>Desenvolvedor full stack apaixonado por transformar negócios no digital. Fundou a IglooCode para provar que é possível ter um site profissional, bonito e que <span class="highlight-blue">realmente funciona</span>, sem pagar caro por isso.</p>
        <p>Cada projeto recebe atenção total: do entendimento do negócio até a entrega final. Sem terceiros, sem retrabalho. <span class="highlight-blue">Você fala direto comigo.</span></p>
      </div>
    </div>
  </div>
</section>

<app-footer></app-footer>
